var map = {
	"./example-00-a-music/game.js": "./src/lib/edu/example-00-a-music/game.js",
	"./example-00-mausart/game.js": "./src/lib/edu/example-00-mausart/game.js",
	"./example-01-kuehlschrank-memo/game.js": "./src/lib/edu/example-01-kuehlschrank-memo/game.js",
	"./example-02-maus-alarm/game.js": "./src/lib/edu/example-02-maus-alarm/game.js",
	"./example-03-zahlen-raten/game.js": "./src/lib/edu/example-03-zahlen-raten/game.js",
	"./example-04-luftballon-spiel/game.js": "./src/lib/edu/example-04-luftballon-spiel/game.js",
	"./example-05-einmaleins/game.js": "./src/lib/edu/example-05-einmaleins/game.js",
	"./example-06-suchspiel/game.js": "./src/lib/edu/example-06-suchspiel/game.js",
	"./example-07-weltraum-abenteuer/game.js": "./src/lib/edu/example-07-weltraum-abenteuer/game.js",
	"./example-08-schlaue-maus/game.js": "./src/lib/edu/example-08-schlaue-maus/game.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/lib/edu sync recursive example.+\\/game\\.js$";